<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';

	const dispatch = createEventDispatcher();
	let parseConfiguracoes = [];

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarConfiguracoesAPI(1);
		else 
			replace("/login");
	});

	const carregarConfiguracoesAPI = async () => {
		parseConfiguracoes = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando configurações ...',
		});

		const resposta = await fetch(API('configuracoes'), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			json.dados.forEach( variavel => {
				parseConfiguracoes.push({
					acoes: [{
						url: `#/painel/configuracoes/atualizar/${variavel.tipo}/GLOBAL`,
						texto: 'Configurar'
					}],
					titulo: variavel.tipo,
					descricao: `Valor = ${variavel.valor}`
				});
			});

			parseConfiguracoes = [... parseConfiguracoes];
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: json?.mensagem
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Configurações API">
	
	<GradeCartoes itens={parseConfiguracoes} componente={CartaoRetangulo} flexWrap={false} parametros={{ permitirSelecaoDescricao: true }} />
</PainelBox>
